export const generateErrorMessage = (field: string) => `Please input ${field}.`;

export const generateErrorMessageDropdown = (field: string) => `Please enter ${field}.`;
